import { useQuery } from "./useApi";
import { getLegacyPublications } from "../api/legacy-publications.service";

export function usePublications(
  params: { edition?: string; limit?: number; status?: string } = {},
  options?: { enabled?: boolean },
) {
  const enabled = options?.enabled ?? true;

  return useQuery(
    () => (enabled ? getLegacyPublications(params) : Promise.resolve({ publications: [] })),
    [enabled, params.edition, params.limit, params.status],
  );
}
